import moment from 'moment';

// NB - mapping should consider incoming data immutable!

// Server sends eventTime as a literal `"new Date(y, m, d, h, mi, s, ms)"` string.
function parseEventTime(value) {
  const match = typeof value === 'string' && value.match(/^\s*new Date\((.*)\)\s*$/);
  if (!match) {
    return value;
  }
  return new Date(...match[1].split(',').map((s) => Number(s.trim())));
}

// tasks/5?getPermissions=1
const idFromLink = (url) =>
  url && url.slice(url.lastIndexOf('/') + 1, url.includes('?') ? url.indexOf('?') : undefined);

// Comments that hang off a task: the parent task isn't in the payload, so derive it
// from the link. Shared by task comments and email comments.
function mapTaskCommentEvent(mapped) {
  return {
    ...mapped,
    extraInfo: {
      ...mapped.extraInfo,
      objectType: 'task',
      objectId: parseInt(idFromLink(mapped.extraLink) || idFromLink(mapped.itemLink), 10),
      taskListId: parseInt(mapped.extraInfo.taskListId, 10),
    },
  };
}

const typeMapping = {
  statusupdate: (mapped) => ({ ...mapped, itemLink: 'people/statuses' }),
  task: (mapped) => ({
    ...mapped,
    parentItemId: parseInt(mapped.parentItemId || idFromLink(mapped.extraLink), 10),
    extraInfo: {
      ...mapped.extraInfo,
      taskListId: mapped.extraInfo.taskListId && parseInt(mapped.extraInfo.taskListId, 10),
      parentTaskId: mapped.extraInfo.parentTaskId && parseInt(mapped.extraInfo.parentTaskId, 10),
    },
  }),
  task_comment: mapTaskCommentEvent,
  email_comment: mapTaskCommentEvent,
  // taskcard becomes card
  taskcard: (mapped) => ({ ...mapped, itemType: 'card' }),
};

export default (eventInfo) => {
  let mapped = {
    ...eventInfo,
    itemType: eventInfo.itemType.toLowerCase(),
    twimEventId: eventInfo.twimEventId ? parseInt(eventInfo.twimEventId, 10) : null,
    eventTime: parseEventTime(eventInfo.eventTime),
    eventTimeUTC: moment.utc().format(),
    extraInfo: eventInfo.extraInfo || {},
    lockdownId: eventInfo.lockdownId || '',
    // ugly mapping, but better not to break the existing interface
    isPrivate: !!eventInfo.IsPrivate,
  };

  // Additional mapping rules based on itemType
  if (typeMapping[mapped.itemType]) {
    mapped = typeMapping[mapped.itemType](mapped);
  }

  if (mapped.extraInfo.data) {
    try {
      mapped.extraInfo.data = JSON.parse(mapped.extraInfo.data);
    } catch (e) {
      // not valid json, ignore
    }
  }
  return mapped;
};
